/**
 * Add your config changes here.
 * @module config
 * @example
 * export const settings = {
 *   ...defaultSettings,
 *   port: 4300,
 *   listBlockTypes: {
 *     ...defaultSettings.listBlockTypes,
 *     'my-list-item',
 *   }
 * }
 */

import applyItaliaConfig from '@italia/config/italiaConfig';
import '@plone/volto/config';
import VirtualAssistant from '@package/components/VirtualAssistant/VirtualAssistant';

export default function applyConfig(voltoConfig) {
  let config = applyItaliaConfig(voltoConfig);

  config.settings = {
    ...config.settings,
    matomoSiteId: 'g7pYPPE3vM',
    matomoUrlBase: 'https://ingestion.webanalytics.italia.it/',
    siteProperties: {
      ...config.settings.siteProperties,
      siteTitle: "Camera di Commercio dell'Umbria",
      siteSubtitle: '',
      parentSiteTitle: 'Unioncamere',
      parentSiteURL: 'http://www.unioncamere.gov.it/',
      subsiteParentSiteTitle: "Camera di Commercio dell'Umbria",
      headerslimTertiaryMenu: {
        it: [
          {
            title: 'Accedi',
            url: 'https://unioncamere.my.site.com/cciaaUmbria/s/login/?ec=302&startURL=%2FcciaaUmbria%2Fs%2F',
          },
          {
            title: 'Registrati',
            url: 'https://unioncamere.my.site.com/cciaaUmbria/s/registration',
          },
        ],
      },
    },
  };

  config.settings.italiaThemeViewsConfig.imagePosition = 'documentBody'; // possible values: afterHeader, documentBody

  config.settings['volto-blocks-widget'].allowedBlocks = [
    ...config.settings['volto-blocks-widget'].allowedBlocks,
    'listing',
  ];

  config.settings['volto-gdpr-privacy'] = {
    ...config.settings['volto-gdpr-privacy'],
    defaultPanelConfig: {
      ...config.settings['volto-gdpr-privacy'].defaultPanelConfig,
      last_updated: '2025-05-29T13:15:00+00:00',
      text: {
        it: {
          title: 'Usiamo i cookies',
          description:
            "Questo sito utilizza i cookie tecnici di navigazione e di sessione per garantire un miglior servizio di navigazione del sito, e cookie analitici per raccogliere informazioni sull'uso del sito da parte degli utenti.  Utilizza anche cookie di profilazione dell'utente per fini statistici. I cookie di profilazione puoi decidere se abilitarli o meno cliccando sul pulsante 'Cambia le impostazioni'. Per saperne di più su come disabilitare i cookie oppure abilitarne solo alcuni, consulta la nostra <a href='/privacy-policy/informativa-sito-web-istituzionale' target='_blank'>Cookie Policy.</a>",
        },
        en: {
          title: 'We use cookies',
          description:
            "This site uses technical navigation and session cookies to ensure a better site navigation service, and analytical cookies to collect information on the use of the site by users. It also uses user profiling cookies for statistical and remarketing purposes. For profiling cookies you can decide whether to enable them or not by clicking on the 'Change settings' button. To find out more, on how to disable cookies or enable only some of them, consult our <a href='privacy-policy/informativa-sito-web-istituzionale target='_blank'>Cookie Policy</a>.",
        },
        fr: {
          title: 'We use cookies',
          description:
            "Ce site utilise des cookies techniques de navigation et de session pour assurer un meilleur service de navigation sur le site, et des cookies analytiques pour collecter des informations sur l'utilisation du site par les utilisateurs. Il utilise également des cookies de profilage des utilisateurs à des fins statistiques et de remarketing. Pour les cookies de profilage, vous pouvez décider de les activer ou non en cliquant sur le bouton « Modifier les paramètres ». Pour en savoir plus, sur la façon de désactiver les cookies ou d'en activer seulement certains, consultez notre <a href='privacy-policy/informativa-sito-web-istituzionale target='_blank'>Politique des cookies</a>.",
        },
      },
      technical: {
        ...config.settings['volto-gdpr-privacy'].defaultPanelConfig.technical,
        choices: [
          {
            config_key: 'MATOMO',
            text: {
              it: {
                title: 'Matomo',
                description:
                  "I cookie di Matomo sono usati per analizzare la navigazione sul sito al fine di migliorarla e fornire all'utente un'esperienza di navigazione migliore possibile.",
              },
              en: {
                title: 'Matomo',
                description:
                  'Matomo cookie are used to analyze navigation on the site in order to improve it and provide the user with the best possible browsing experience.',
              },
              fr: {
                title: 'Matomo',
                description:
                  "Les cookie de Matomo sont utilisés pour analyser la navigation sur le site afin de l'améliorer et offrir à l'utilisateur la meilleure expérience de navigation possible.",
              },
            },
          },
          /*...config.settings[
            'volto-gdpr-privacy'
          ].defaultPanelConfig.technical.choices.filter(
            (f) => f.config_key !== 'GANALYTICS',
          ),*/
        ],
      },
    },
  };
  config.settings.appExtras = [
    ...(config.settings.appExtras || []),
    {
      match: '',
      component: VirtualAssistant,
    },
  ];

  delete config.widgets.id.description; //remove limit on description field

  return config;
}
